module.exports = __webpack_public_path__ + "img/tassie2.eb12b0a.jpg";